/**
 * Shared constants and filter rules for invoice lists
 */

/**
 * Base required fields for all invoice lists
 */
export const BASE_REQUIRED_FIELDS = [
	'_id',
	'externalId',
	'externalId2',
	'invoiceNumber',
	'date',
	'dueDate',
	'_fk_client__id',
	'fk_company__id',
	'clientName',
	'clientExternalId',
	'clientExternalId2',
	'clientAddress1',
	'clientAddress2',
	'clientCity',
	'clientState',
	'clientZip',
	'total',
	'companyName',
];

/**
 * Extended required fields for the "All" list (includes all column data)
 */
export const ALL_REQUIRED_FIELDS = [
	...BASE_REQUIRED_FIELDS,
	'numberOfLines',
	'tax',
	'freight',
	'discount',
	'subtotal',
	'salesRepFirstName',
	'm_sm_payment_outstandingBalance',
	'paymentStatus',
	'totalGP',
];

/**
 * Required fields for aging bucket lists (outstanding balance + payment status needed)
 */
export const AGING_REQUIRED_FIELDS = [
	...BASE_REQUIRED_FIELDS,
	'm_sm_payment_outstandingBalance',
	'paymentStatus',
];

/**
 * Base filter rules applied to all invoice lists
 */
export const BASE_FILTER_RULES = {
	invoiceSalesRep: {
		defaultValue: [{ id: 'ME', label: 'Me' }],
		applyDefaultIf: {
			type: 'group',
			joiner: 'AND',
			negated: false,
			children: [{ type: 'rule', action: 'invoices:view:any', negated: true }],
		},
		lockedIf: {
			type: 'group',
			joiner: 'AND',
			negated: false,
			children: [{ type: 'rule', action: 'invoices:view:any', negated: true }],
		},
		hiddenIf: {
			type: 'group',
			joiner: 'AND',
			negated: false,
			children: [{ type: 'rule', action: 'invoices:view:any', negated: true }],
		},
	},
	invoiceDateRange: {
		defaultValue: [
			{
				id: 'last-90-days',
				label: 'Last 90 Days',
				data: {
					startDate: '{{DATE:-90d}}',
					endDate: '{{DATE:0d}}',
				},
			},
		],
	},
};
